import { DocumentRequirementKey } from "./globalTypes";

export const DocumentRequirementKeyList: Record<DocumentRequirementKey, { key: DocumentRequirementKey; name: string }> =
  {
    [DocumentRequirementKey.NONE]: { key: DocumentRequirementKey.NONE, name: "Not required" },
    [DocumentRequirementKey.SUBMISSION]: { key: DocumentRequirementKey.SUBMISSION, name: "Required for submission" },
    [DocumentRequirementKey.REQUEST_AND_SUBMISSION]: {
      key: DocumentRequirementKey.REQUEST_AND_SUBMISSION,
      name: "Required for request and submission",
    },
  };
